<div>
  <div fxLayout="row" class="snack-container">
    <div>
      <mat-icon>{{ getIcon }}</mat-icon>
    </div>
    <div class="pl10" [ngClass]="data.snackType">
      <span>{{ data.message }}</span>
    </div>
    <span>
      <mat-icon *ngIf="!hideCloseButton" class="cursor-pointer" (click)="close()">close</mat-icon>
    </span>
  </div>
  <div *ngIf="data.trackingId" >
    <span class="pl34">TrackingID: {{ data.trackingId }} </span>
    <span class="copy-clipboard fs20" title="Copy To Clipboard"
    >
      <mat-icon (click)="copyToClipBoard()">content_copy</mat-icon><small class="fs10" *ngIf="tractIdCopied">Copied</small>
    </span>
  </div>
</div>
